import {VehicleSelectionListFieldName} from '../../../types/VehicleSelectionFormBinding';

type ListAttributeFields = {
  includeField: VehicleSelectionListFieldName;
  excludeField: VehicleSelectionListFieldName;
};

// The list attributes of the vehicle selection, keyed by the BE attribute code of the catalog
// (`GET /dms/v1/vehicle-selection/attributes`), with the request fields carrying their "any of"
// and "everything except" lists. Vehicle type is not here: its include side is a single value.
export const VEHICLE_SELECTION_LIST_ATTRIBUTES = {
  BRANCH: {includeField: 'branchIds', excludeField: 'excludedBranchIds'},
  SALE_PRESET: {includeField: 'salePresetIds', excludeField: 'excludedSalePresetIds'},
  CONDITION: {includeField: 'vehicleConditions', excludeField: 'excludedVehicleConditions'},
  MAKE: {includeField: 'makes', excludeField: 'excludedMakes'},
  MODEL: {includeField: 'models', excludeField: 'excludedModels'},
  MODEL_FAMILY: {includeField: 'modelFamilies', excludeField: 'excludedModelFamilies'},
  FUEL_TYPE: {includeField: 'fuelTypes', excludeField: 'excludedFuelTypes'},
  BODY_STYLE: {includeField: 'bodyStyles', excludeField: 'excludedBodyStyles'},
  TAGS: {includeField: 'tagIds', excludeField: 'excludedTagIds'},
} as const satisfies Record<string, ListAttributeFields>;

export type VehicleSelectionListAttribute = keyof typeof VEHICLE_SELECTION_LIST_ATTRIBUTES;
